import { OptionType } from "components/UI/CustomSelect";
import { Barrels, BigBag, Box, Pipes, Rolls, Sack } from "components/UI/Icons";
import { ValueOf } from "utils/typeCheck.utils";

export const PACKAGE_TYPE = {
  BOX: "box",
  BIG_BAGS: "big-bags",
  BARRELS: "barrels",
  SACKS: "sacks",
  PIPES: "pipes",
  ROLLS: "rolls",
} as const;

export type PackageOptionType = Omit<OptionType, "value"> & {
  value: ValueOf<typeof PACKAGE_TYPE>;
};

export const PACKAGE_OPTIONS: PackageOptionType[] = [
  { value: PACKAGE_TYPE.BOX, label: "Box", icon: <Box /> },
  { value: PACKAGE_TYPE.BIG_BAGS, label: "Big Bags", icon: <BigBag /> },
  { value: PACKAGE_TYPE.BARRELS, label: "Barrels", icon: <Barrels /> },
  { value: PACKAGE_TYPE.SACKS, label: "Sacks", icon: <Sack /> },
  { value: PACKAGE_TYPE.PIPES, label: "Pipes", icon: <Pipes /> },
  { value: PACKAGE_TYPE.ROLLS, label: "Rolls", icon: <Rolls /> },
];
